import {
  Body,
  Container,
  H3,
  MaterialIcon,
  Stack,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';

const Finished = () => {
  const t = useTranslate();
  const { isMobile } = useWindowProperties();

  return (
    <Stack
      data-testid="update-application-finished"
      spacing={0}
      style={{
        backgroundImage: 'url(/swoosh.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPositionY: '90%',
        backgroundSize: 'contain',
      }}
    >
      <Stack
        spacing="xxl"
        align="center"
        justify="center"
        p="1.5em"
        style={{
          flexGrow: 0.5,
        }}
      >
        <MaterialIcon src="verified" filled size="48" color="Icon/Success" />
        <H3 data-record>{t('UpdateApplication.SuccessfullyFinishedTitle')}</H3>
        <Body size="lg" data-record>
          {t('UpdateApplication.SuccessfullyConnectedDescription')}
        </Body>
        <Container
          display={'flex'}
          pos={isMobile ? 'fixed' : 'static'}
          bottom="0"
          p={isMobile ? 'lg' : 0}
          w="100%"
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        ></Container>
      </Stack>
    </Stack>
  );
};

export default Finished;
